// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta.skip-main{left:2em;opacity:0;pointer-events:none;top:0;transform:translateY(-100%);transition:opacity var(--fade-speed),transform var(--fade-speed);z-index:170}.cta.skip-main:active,.cta.skip-main:focus{opacity:1;pointer-events:auto;transform:translateY(1rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
